import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReciprocatingCompressor2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 65,
	viewBox: "0 0 50.0 65.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 23.0 L 50.0 23.0 M 0.0 27.0 L 50.0 27.0 M 25.0 27.0 L 25.0 65.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgReciprocatingCompressor2;
